"use client"

import * as React from "react"
import { TextMorph as TorphTextMorph } from "torph/react"

import { cn } from "@/lib/utils"

/**
 * TextMorph — wrapper autour de torph/react.
 *
 * torph (https://torph.lochie.me) anime un changement de texte
 * caractère par caractère sans dépendance externe (pas de motion,
 * pas de framer-motion). Idéal pour les titres qui changent — par
 * exemple le hero carousel d'ADIS 95 qui passe d'« AFFÛTAGE DE VOS
 * OUTILS » à « OUTILLAGE FESTOOL, CMT… » sans crossfade brutal.
 *
 * Réglages par défaut :
 *   - `respectReducedMotion: false` — l'utilisateur a explicitement
 *     demandé que l'animation reste « full beautiful » même si l'OS
 *     déclare prefers-reduced-motion. La morph reste douce (spring
 *     physics organique, durée ≥ 400 ms) donc la pénalité a11y est
 *     minime.
 *   - `scale: true` — la scale animation des segments entrants/
 *     sortants ne change PAS la box du parent (juste un fade+shrink
 *     visuel par caractère). Garder true donne le morph qui fait
 *     l'intérêt du package.
 *   - Spring physics par défaut (stiffness 200, damping 22, mass 0.9)
 *     pour un mouvement organique cohérent avec le reste du site.
 */
type TextMorphProps = React.ComponentProps<typeof TorphTextMorph>

export function TextMorph({
  children,
  className,
  scale = true,
  // Désactivé sur demande utilisateur — toujours animer, jamais
  // dégrader visuellement même quand l'OS signale reduced-motion.
  respectReducedMotion = false,
  ease = { stiffness: 200, damping: 22, mass: 0.9, precision: 0.01 },
  ...rest
}: TextMorphProps) {
  return (
    <TorphTextMorph
      {...rest}
      scale={scale}
      respectReducedMotion={respectReducedMotion}
      ease={ease}
      className={cn(className)}
    >
      {children}
    </TorphTextMorph>
  )
}

export type { TextMorphProps }
